// extracted by mini-css-extract-plugin
module.exports = {"main":"blog-module--main--3ejRR","post":"blog-module--post--35Kj9","postProps":"blog-module--post-props--RTeGC","button":"blog-module--button--6KYUm"};